<template>
  <app-modal
    v-if="show"
    :maxWidth="maxWidth"
    :maxHeight="maxHeight"
    :minWidth="minWidth"
    :isClickMaskClose="false"
    :fullHeight="isNewMode"
    @close="hideModal"
  >
    <div class="attr-gallery-new">
      <h2>{{ title }}</h2>

      <the-file-uploader
        v-if="isNewMode"
        class="attr-gallery-new__file-uploader"
      />

      <div class="attr-gallery-new__content">
        <div v-if="isNewMode" class="attr-gallery-new__content_left">
          <the-picture-editor
            class="attr-gallery-new__editor"
            :fileName="fileName"
            @preview="preview"
          />

          <div class="attr-gallery-new__detail_preview">
            <img
              v-if="previewImageUrl"
              class="attr-gallery-new__detail_preview_image"
              :src="previewImageUrl"
              :style="previewImageStyle"
              alt="previewImgUrl"
            />
            <div
              v-else
              class="attr-gallery-new__detail_preview_image cropper-bg"
              :style="previewImageStyle"
            ></div>
          </div>
        </div>

        <div
          :class="[
            'attr-gallery-new__content_right',
            { 'attr-gallery-new__content_right_editeble': isEditMode }
          ]"
        >
          <attr-gallery-new-form
            :fileName="fileNameByMode"
            :title="galleryNewFormTitle"
            :languages="languages"
            :galleryNames="galleryNames"
            :nextOrderNum="nextOrderNum"
            :editableObject="editableObject"
            :editMode="isEditMode"
            :disabled="!fileNameByMode"
            class="attr-gallery-new__detail_attr-form panel"
            @close="hideModal"
            @save="saveForm"
          />
        </div>
      </div>

      <el-button
        class="attr-gallery-new_close"
        icon="el-icon-close"
        type="primary"
        circle
        :title="$t('attr_value_new_gallery_close')"
        @click="hideModal"
      ></el-button>
    </div>
  </app-modal>
</template>

<script>
import AttrGalleryNewForm from "./AttrGalleryNewForm.vue";

import { MODE_EDIT, MODE_NEW } from "@/domain/mode.types";

export default {
  name: "AttributeValueGalleryNew",
  components: {
    AttrGalleryNewForm,
    AppModal: () =>
      import(
        /* webpackChunkName: "appModal" */ "@/components/library.blocks/AppModal.vue"
      ),
    ThePictureEditor: () =>
      import(
        /* webpackChunkName: "thePictureEditor" */ "@/components/library.blocks/ThePictureEditor/ThePictureEditor.vue"
      ),
    TheFileUploader: () =>
      import(
        /* webpackChunkName: "theFileUploader" */ "@/components/library.blocks/TheFileUploader/TheFileUploader.vue"
      )
  },
  props: {
    maxWidth: {
      type: String,
      default: "100%"
    },
    maxHeight: {
      type: String,
      default: ""
    },
    minWidth: {
      type: String,
      default: ""
    },
    show: {
      type: Boolean,
      default: false
    },
    complexValue: Object,
    previewImageUrl: String,
    fileName: String,
    languages: Array,
    widthImgage: Number,
    heightImage: Number,
    galleryNames: Array,
    nextOrderNum: Number,
    mode: {
      type: String,
      default: MODE_NEW
    },
    editableObject: Object
  },
  data() {
    return {};
  },
  computed: {
    previewImageStyle() {
      return {
        width: `${this.widthImgage}px`,
        height: `${this.heightImage}px`,
        maxWidth: "100%"
      };
    },
    isNewMode() {
      return this.mode === MODE_NEW;
    },
    isEditMode() {
      return this.mode === MODE_EDIT;
    },
    fileNameByMode() {
      if (this.isEditMode) {
        if (this.editableObject && this.editableObject.fileName) {
          return this.editableObject.fileName;
        }
      }
      return this.fileName;
    },
    title() {
      return this.isNewMode
        ? this.$t("attr_value_new_gallery_append_title")
        : this.$t("attr_value_new_gallery_change_title");
    },
    galleryNewFormTitle() {
      return this.isNewMode
        ? this.$t("attr_value_new_gallery_save_title")
        : this.$t("attr_value_new_gallery_change_description_title");
    }
  },
  methods: {
    hideModal() {
      this.$emit("close");
    },
    preview() {
      this.$emit("preview");
    },
    saveForm(obj) {
      this.$emit("saveForm", obj);
    }
  }
};
</script>

<style lang="scss">
@import "@/css/variables.scss";

.attr-gallery-new {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  padding-bottom: 0;

  .attr-gallery-new__file-uploader {
    margin-top: $component_padding_on_top;
    height: 100px;
  }

  .attr-gallery-new__content {
    display: flex;
    margin-top: $component_padding_on_top;

    .attr-gallery-new__content_left {
      width: 70%;

      .attr-gallery-new__editor {
        height: 418px;
      }

      .attr-gallery-new__detail_preview {
        width: 100%;
        text-align: center;
        margin-top: $element_padding_on_top;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;

        .attr-gallery-new__detail_preview_image {
          width: 100%;
          height: 100%;
        }
      }
    }

    .attr-gallery-new__content_right {
      width: 30%;
      margin-left: 15px;
    }

    .attr-gallery-new__content_right_editeble {
      width: 100%;
      margin-left: 0;
    }
  }

  .attr-gallery-new_close {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style>
